import request from '@/utils/request'


// 查询商品属性列表
export function listGoodsProperty(query) {
  return request({
    url: '/biz/admin/goods/property/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

export function sortProperty(query) {
  return request({
    url: '/biz/admin/goods/property/sort',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询商品属性分页
export function pageGoodsProperty(query) {
  return request({
    url: '/biz/admin/goods/property/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

export function existGoodsProperty(query) {
  return request({
    url: '/biz/admin/goods/property/exist',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

export function copyGoodsProperty(query) {
  return request({
    url: '/biz/admin/goods/property/copy',
    method: 'post',
    data: query
  })
}

export function copyGoodsIdProperty(query) {
  return request({
    url: '/biz/admin/goods/property/copy/id',
    method: 'post',
    data: query
  })
}

// 查询商品属性详细
export function getGoodsProperty(data) {
  return request({
    url: '/biz/admin/goods/property/detail',
    method: 'get',
    params: data
  })
}

// 新增商品属性
export function addGoodsProperty(data) {
  return request({
    url: '/biz/admin/goods/property/add',
    method: 'post',
    data: data
  })
}

// 修改商品属性
export function updateGoodsProperty(data) {
  return request({
    url: '/biz/admin/goods/property/edit',
    method: 'post',
    data: data
  })
}

// 删除商品属性
export function delGoodsProperty(data) {
  return request({
    url: '/biz/admin/goods/property/delete',
    method: 'post',
    data: data
  })
}
